export default __webpack_public_path__ + "static/media/CNo.92-6.13f83cc0.jpg";